import React from 'react';

import dayjs from '~/timeInit';

import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid';

import {
  type AnyItem,
  type DateValidationError,
  type EditableItem,
  type ItemWithDates,
  getDateError,
  isDateEditable,
} from './atolEditHelpers';

interface AtolDatedFieldsEditorProps {
  editItem: EditableItem;
  dateErrors: Array<DateValidationError>;
  isLoading: boolean;
  onUpdateField: (itemId: string, updater: (current: AnyItem) => AnyItem) => void;
}

export default function AtolDatedFieldsEditor({
  editItem,
  dateErrors,
  isLoading,
  onUpdateField,
}: AtolDatedFieldsEditorProps) {
  const { groupKey, current } = editItem;

  if (!isDateEditable(groupKey)) {
    return null;
  }

  const datedItem = current as ItemWithDates;
  const startDate = datedItem.startDate ?? '';
  const endDate = datedItem.endDate ?? '';
  const endDateError = getDateError(dateErrors, current.id, 'endDate');

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="Start Date"
          type="date"
          value={startDate ? dayjs(startDate).format('YYYY-MM-DD') : ''}
          onChange={(e) => {
            const newDate = e.target.value;
            onUpdateField(current.id, (currentItem) => {
              const clone = JSON.parse(JSON.stringify(currentItem)) as ItemWithDates;
              clone.startDate = newDate;
              return clone as AnyItem;
            });
          }}
          fullWidth
          disabled={isLoading}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="End Date"
          type="date"
          value={endDate ? dayjs(endDate).format('YYYY-MM-DD') : ''}
          onChange={(e) => {
            const newDate = e.target.value;
            onUpdateField(current.id, (currentItem) => {
              const clone = JSON.parse(JSON.stringify(currentItem)) as ItemWithDates;
              clone.endDate = newDate;
              return clone as AnyItem;
            });
          }}
          fullWidth
          disabled={isLoading}
          error={!!endDateError}
          helperText={endDateError}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </Grid>
    </Grid>
  );
}
